<template>
  <div class="image-container">
    <div style="position: relative">
      <img v-if="AbsImagePath" :src="AbsImagePath"
         :srcset="AbsImageSrcsetPath"
         width="100%">
      <div class="bildnachweis" v-if="Bildnachweis !== ''">{{Bildnachweis}}</div>
    </div>
    <div class="bildunterschrift" v-if="Bildunterschrift !== ''">{{Bildunterschrift}}</div>
  </div>
</template>
<script type="text/babel">
export default {
  name: 'UploadedImage',
  props: {
    ImagePath: {},
    ImageCropFormatWidth: {
      type: String,
      default: '800',
    },
    ImageCropFormatHeight: {
      type: String,
      default: '400',
    },
    Bildunterschrift: {
      type: String,
      default: '',
    },
    Bildnachweis: {
      type: String,
      default: '',
    },
    fitwidth: {
      type: Boolean,
      default: false,
    },

  },
  computed: {
    AbsImagePath: function () {

      //console.log(process.env.apiPath);
      //console.log(process.env.BASE_URL);

      if (this.ImagePath && this.ImagePath.length){

        if (this.fitwidth) {
          return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/fitwidth/1100/' + this.ImagePath;
        }

        return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/' + this.ImageCropFormatWidth + 'x' + this.ImageCropFormatHeight + '/' + this.ImagePath;
      } else {
        return ''
      }
    },
    AbsImageSrcsetPath: function () {

      //console.log(process.env.apiPath);
      //console.log(process.env.BASE_URL);

      if (this.ImagePath && this.ImagePath.length){
        /*

        needles-780.jpg  780w,   // Viewport bis zu 780
        needles-1024.jpg 1024w,  // Viewport größer als 780
        needles-1440.jpg 1440w,  // Viewport größer als 1024
        needles-2400.jpg 2400w"  // Viewport größer als 1440
         */

        if (this.fitwidth) {
          return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/fitwidth/780/' + this.ImagePath +' 780w, ' +
            '' + process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/fitwidth/1024/' + this.ImagePath +' 1024w'
        }

        return process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/' + this.ImageCropFormatWidth + 'x' + this.ImageCropFormatHeight + '/' + this.ImagePath +' 780w, ' +
          '' + process.env.VUE_APP_API_ENDPOINT + 'fileman/imgsc/cropto/' + (this.ImageCropFormatWidth*1.8) + 'x' + (this.ImageCropFormatHeight*1.8) + '/' + this.ImagePath +' 1024w'
      } else {
        return ''
      }
    },
  },
}
</script>

<style scoped lang="scss">
  .image-container {
    position: relative;
    margin-bottom: 50px;
  }

  img {
    vertical-align: bottom;
    z-index: 80;
  }
  .bildunterschrift {
    //position: absolute;
    //bottom: -25px;
    width: 100%;
    text-align: center;
    font-weight: 400;
    color: #350f37;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    margin-top: 5px;
  }
  .bildnachweis {
    font-size: 12px;
    line-height: 1;
    color: white;
    font-weight: 600;

    position: absolute;
    right: 20px;
    bottom: 10px;
  }
</style>
